import { Mediator } from "modular-openscriptjs";
import { authenticated } from "../helpers";

export class Utility extends Mediator {
	$$system = {
		needs: {
			reload: () => {
				if(!authenticated()) {
					return window.location.reload();
				}
			},
		},
	};
}
